import api from "src/shared/api";
import { EQueryTagTypes } from "src/shared/types/api";
import {
  IGetLastUpdateResponse,
  IGetServiceToolsQuery,
  IServiceToolsResponse,
  IUpdateServiceToolsBody,
} from "../types";

const serviceToolsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getServiceTools: build.query<IServiceToolsResponse, IGetServiceToolsQuery>({
      query: (params) => ({
        url: "api/service-tools/settings",
        method: "GET",
        params,
      }),
    }),
    updateServiceTools: build.mutation<void, IUpdateServiceToolsBody>({
      query: (body) => ({
        url: "api/service-tools/settings/batch-update",
        method: "PATCH",
        body,
      }),
      invalidatesTags: (_res, _err, body) => [
        { type: EQueryTagTypes.SERVICE_TOOLS, id: "LIST" },
        {
          type: EQueryTagTypes.SERVICE_TOOLS,
          id: `${body.agency}-${body.cooperation_type}`,
        },
        { type: EQueryTagTypes.SERVICE_TOOLS_AUDIT, id: "LAST" },
      ],
    }),
    getLastUpdate: build.query<IGetLastUpdateResponse, null>({
      query: () => ({
        url: "api/service-tools/settings/audit",
        method: "GET",
      }),
      providesTags: [{ type: EQueryTagTypes.SERVICE_TOOLS_AUDIT, id: "LAST" }],
    }),
    checkLaunchedProcesses: build.query({
      query: () => ({
        url: `/api/service-tools/settings/check-launched-processes`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetServiceToolsQuery,
  useUpdateServiceToolsMutation,
  useGetLastUpdateQuery,
  useCheckLaunchedProcessesQuery,
  useLazyCheckLaunchedProcessesQuery,
} = serviceToolsApi;
